import { cn } from "@/zapi-frontend/shared/lib/utils";

type TProjectLoadingScreenProps = {
  size?: "md" | "sm";
  className?: string;
};

const SIZES = {
  md: { box: "size-[88px]", logo: { width: 27, height: 25 } },
  sm: { box: "size-[48px]", logo: { width: 15, height: 14 } }
};

export function ProjectLoadingScreen({ size = "md", className }: TProjectLoadingScreenProps) {
  const { box, logo } = SIZES[size];

  return (
    <div className={cn("relative flex items-center justify-center", box, className)} role="status" aria-label="Loading">
      <div className="absolute inset-0 rounded-full border border-innoveraZinc-150" />
      <div className="absolute inset-0 rounded-full border border-transparent border-t-innoveraZinc-400 animate-spin [animation-duration:1.6s]" />
      <svg
        width={logo.width}
        height={logo.height}
        viewBox="0 0 26.4696 24.6858"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="animate-logoBreath"
      >
        <path
          d="M13.8046 0.304036H12.6627L0.51756 24.3819H14.0228L13.395 22.9515L2.93243 22.9814L5.68034 17.5435H5.68383L7.39315 14.1782L13.2348 2.57283L19.0765 14.1782L20.7858 17.5435H20.7893L24.2439 24.383H25.9521L13.8046 0.304036Z"
          fill="#D4D4D8"
        />
        <path
          d="M26.4696 24.6849H24.0339L13.236 3.29493L3.45115 22.6762L13.6178 22.6475L14.5113 24.6858H0L12.4527 0H14.0158L14.104 0.176L26.4696 24.6849ZM24.4551 24.0778H25.4357L13.5945 0.606933H12.8739L1.03511 24.0778H13.5342L13.1733 23.2545L2.41487 23.2853L7.09493 14.049L13.236 1.8496L24.4563 24.0778H24.4551Z"
          fill="#D4D4D8"
        />
      </svg>
    </div>
  );
}
